import React from 'react'
import MainContentsWithSidebarInbox from 'components/templates/MainContentsWithSidebarInbox'
import ModalSelect from 'components/organisms/ModalSelect'
import LoadingView from 'components/atoms/LoadingView'

type PropTypes = {
  sidebarComponent: ?any,
  isShowContentsSp?: ?boolean,
  isModalActive?: ?boolean,
  isLoading?: ?boolean,
  onClickPositiveButton: Function,
  closeModal: Function,
}

export default function ReservationEditPage(props: PropTypes) {
  const { reservationEdit } = props
  const unapprovedReservation = (reservationEdit || {}).unapprovedReservation
  const isNeedAdditionalPaidyChargeForChange = (
    (unapprovedReservation || {}).billing || {}
  ).is_need_additional_paidy_charge_for_change

  let positiveText = i18n.t(
    'page.dashboard.reservation.editRequestModal.positive',
  )
  let isButtonTwoBlock = false
  let attentionText = ''
  if (isNeedAdditionalPaidyChargeForChange) {
    positiveText = i18n.t('page.shared.l_00072')
    isButtonTwoBlock = true
    attentionText = i18n.t('page.dashboard.reservation.addPaidyPopupAttention')
  }

  return (
    <React.Fragment>
      <MainContentsWithSidebarInbox
        sidebarInbox={props.sidebarComponent}
        isShowContentsSp={props.isShowContentsSp}
      >
        {props.children}
      </MainContentsWithSidebarInbox>
      <ModalSelect
        title={i18n.t('page.dashboard.reservation.editRequestModal.title')}
        textList={[i18n.t('page.dashboard.reservation.editRequestModal.text')]}
        positiveButton={{
          text: positiveText,
          onClick: props.onClickPositiveButton,
        }}
        negativeButton={{
          text: i18n.t('page.shared.cancel'),
          onClick: props.closeModal,
        }}
        isActive={!!props.isModalActive}
        onClickClose={props.closeModal}
        isButtonTwoBlock={isButtonTwoBlock}
        attentionText={attentionText}
      />
      {props.isLoading && <LoadingView />}
    </React.Fragment>
  )
}



// WEBPACK FOOTER //
// ./src/components/pages/ReservationEditPage/index.jsx